import React from "react";

/**
 * Soft atmospheric background — matches stylion-io marketing (cream, sky, peach, mint).
 */
export const StylionAtmosphere = () => (
  <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden" aria-hidden>
    <div className="absolute inset-0 bg-[var(--stylion-cream,#fdfcfb)] transition-opacity duration-500 dark:opacity-0" />

    <div className="absolute inset-0 opacity-100 transition-opacity duration-500 dark:opacity-0">
      <div
        className="absolute -left-[20%] top-[-15%] h-[55vh] w-[55vw] rounded-full opacity-70 blur-3xl"
        style={{
          background:
            "radial-gradient(circle, hsl(199 87% 48% / 0.18) 0%, hsl(199 87% 48% / 0) 70%)",
        }}
      />
      <div
        className="absolute -right-[10%] top-[5%] h-[45vh] w-[45vw] rounded-full opacity-60 blur-3xl"
        style={{
          background:
            "radial-gradient(circle, hsl(340 60% 85% / 0.55) 0%, transparent 70%)",
        }}
      />
      <div
        className="absolute bottom-[-10%] left-[25%] h-[50vh] w-[50vw] rounded-full opacity-50 blur-3xl"
        style={{
          background:
            "radial-gradient(circle, hsl(168 70% 42% / 0.14) 0%, transparent 70%)",
        }}
      />
      <div
        className="absolute bottom-[10%] right-[15%] h-[35vh] w-[35vw] rounded-full opacity-40 blur-3xl"
        style={{
          background: "radial-gradient(circle, #ffe0d1 0%, transparent 70%)",
        }}
      />
    </div>

    <div className="absolute inset-0 opacity-0 transition-opacity duration-500 dark:opacity-100">
      <div
        className="absolute inset-0"
        style={{
          background: `
            radial-gradient(circle at 30% 20%, hsl(199 87% 48% / 0.12) 0%, transparent 45%),
            radial-gradient(circle at 80% 70%, hsl(168 70% 42% / 0.08) 0%, transparent 50%),
            linear-gradient(160deg, hsl(25 18% 10%) 0%, hsl(220 25% 12%) 100%)
          `,
        }}
      />
    </div>
  </div>
);
